














































































import { Component, Prop, Vue } from "vue-property-decorator";
import { downloadImage } from "@/services/getImage";
import { type } from "@/config/files.config.json";
import { splitString } from "@/services/strings";
import { Cropper } from "vue-advanced-cropper";
import { pics } from "@/config/host.config";
import Progress from "./progress.vue";
import StandartModal from "@/components/app/standart-modal.vue";

interface IWH {
  width: number;
  height: number;
}

@Component({
  components: { StandartModal, Cropper, Progress },
})
export default class UloadCroppingPictures extends Vue {
  @Prop({ type: String, default: "" }) image!: string;
  @Prop({ type: String, default: "" }) folder!: string;
  @Prop({ type: Object, default: null }) widthHeight!: IWH;
  @Prop({ type: String, default: "poster" }) upload!: string;
  @Prop({ type: Number, default: 16 / 9 }) aspectRatio!: number;

  saweNameToggle = false;
  ar = {
    aspectRatio: this.aspectRatio,
  };

  // progress
  poster_prodress_variant = "primary";
  poster_value_progress = 0;
  poster_progress = false;

  poster = this.image;
  posterName = "";

  file: null | File = null;
  fullFile: null | File = null;

  $refs!: {
    file: HTMLInputElement;
  };

  isUpload(): void {
    this.fullFile = this.$refs.file.files ? this.$refs.file.files[0] : null;
    if (this.fullFile)
      this.poster = URL.createObjectURL(new Blob([this.fullFile]));
  }

  isChange({ coordinates, canvas }: any): void {
    const imageDataUrl = canvas.toDataURL("img/jpg");
    const arr = imageDataUrl.split(",");
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    this.file = new File([u8arr], "mobile-bg.jpg", { type: "img/jpg" });
  }

  isError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  async isOk(): Promise<void> {
    if (!this.file) {
      this.isError();
      return;
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onDownloadProgress: (event: ProgressEvent) => {
        this.poster_value_progress = Math.round(
          (event.loaded * 100) / event.total
        );
      },
      params: {
        path: this.folder,
        name: this.saweNameToggle,
        poster_name: this.saweNameToggle ? this.posterName : "",
        resizewidth: this.widthHeight ? this.widthHeight.width : undefined,
        resizeheight: this.widthHeight ? this.widthHeight.height : undefined,
      },
    };
    const uri = pics.upload;
    const formData: FormData = new FormData();
    formData.append("poster", this.file);

    try {
      const res = await this.$axios.post(uri, formData, config);
      if (res.status === 200) {
        this.$emit("changePoster", res.data);
        this.$bvModal.hide(`${this.upload}Modal`);
      }
    } catch (error) {
      this.isError();
      this.poster_prodress_variant = "danger";
    }
  }

  async makeActive(): Promise<void> {
    if (!this.image) return;
    downloadImage(pics.download, this.image, this.folder + "/full")
      .then((image: Blob) => {
        this.poster = URL.createObjectURL(new Blob([image]));
        this.posterName = this.image;
      })
      .catch((error) => {
        console.log(error);
        this.isError();
      });
  }

  fileFormat(string: string | undefined): boolean {
    if (!string) return false;
    const split_arr = splitString(string, "/");
    return type.image.includes(split_arr[split_arr.length - 1]);
  }

  onReset(): void {
    this.file = null;
    this.fullFile = null;
    this.saweNameToggle = false;
    this.makeActive();
  }

  mounted(): void {
    this.$nextTick(() => this.makeActive());
  }
}
